
type LDateType = 'day' | 'week' | 'minute' | 'second' | 'hour'

const addByDatePart: Record<LDateType, (date: Date, amount: number) => Date> = {
    second: (date, amount) => new Date(date.getTime() + amount * 1000),
    minute: (date, amount) => new Date(date.getTime() + amount * 60 * 1000),
    hour: (date, amount) => new Date(date.getTime() + amount * 60 * 60 * 1000),
    day: (date, amount) => new Date(date.getTime() + amount * 24 * 60 * 60 * 1000),
    week: (date, amount) => new Date(date.getTime() + amount * 7 * 24 * 60 * 60 * 1000)
}


export const dateUtils = {
    add: (part: LDateType, date: Date, amount: number) => addByDatePart[part](date, amount),
    diffDays: (date1: Date, date2: Date) => Math.round((date1.getTime() - date2.getTime()) / 1000 / 60 / 60 / 24)
}